export default "__VITE_ASSET__CsGrJcO9__"